module.exports = __webpack_public_path__ + "static/assets/68a424e2cf438170c991e1abfb2a4f87.png";